import { logBalanceOrigins } from '../../../config/commons';

export const initialHistoryManagementFilters = {
  userIdSelected: '',
  logBalanceOrigin: logBalanceOrigins.ALL,
};
